
export const messages = {
  en: {
    adminFeeDetail: {
      feeInfo: 'Fee Information',
      paymentRecord: 'Payment Record',
      relatedRoom: 'Related Room',
      relatedCar: 'Related Car',
      relatedContract: 'Related Contract',
      modifyRecord: 'Modify Record',
      feeItem: 'Fee Item',
      owner: 'Owner',
      sameFeeObj: 'Same Fee Object',
      relatedMeter: 'Related Meter',
      relatedImport: 'Related Import',
      discountApply: 'Discount Application',
      reprintReceipt: 'Reprint Receipt',
      feeSplit: 'Fee Split'
    },
    adminFeeDetailInfo: {
      feeId: 'Fee ID',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      payerObj: 'Payer Object',
      feeItem: 'Fee Item',
      feeState: 'Fee State',
      createTime: 'Create Time',
      batchId: 'Batch ID',
      startTime: 'Start Time',
      endTime: 'End Time',
      owedAmount: 'Owed Amount'
    },
    aRoomDetailCar: {
      placeholderCarNum: 'Please enter license plate number',
      carNum: 'License Plate',
      leaseType: 'Plate Type',
      tempCar: 'Temporary Car',
      carType: 'Vehicle Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      released: 'Released',
      validity: 'Validity'
    },
    aFeeDetailHis: {
      feeName: 'Fee Item',
      startTime: 'Account Time',
      endTime: 'Billing Start Time',
      operation: 'Action',
      operator: 'Operator',
      operationTime: 'Operation Time',
      add: 'Add',
      delete: 'Delete',
      modifyNew: 'Modify(New)',
      modifyOld: 'Modify(Old)'
    },
    aFeeDetailConfig: {
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      billType: 'Bill Type',
      paymentType: 'Payment Type',
      prepay: 'Prepay',
      postpay: 'Postpay',
      paymentCycle: 'Payment Cycle',
      unit: 'Unit',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      accountDeduction: 'Account Deduction',
      mobilePayment: 'Mobile Payment',
      decimalPlaces: 'Decimal Places',
      yes: 'Yes',
      no: 'No'
    },
    aFeeDetailFeeObj: {
      selectFeeObj: 'Please select fee object',
      house: 'House',
      car: 'Car',
      contract: 'Contract',
      feeId: 'Fee ID',
      objType: 'Object Type',
      objName: 'Object Name',
      ownerName: 'Owner Name',
      phone: 'Phone',
      createTime: 'Create Time',
      query: 'Query'
    },
    aFeeDetailImport: {
      floorNum: 'Building Number',
      unitNum: 'Unit Number',
      roomNum: 'Room Number',
      feeName: 'Fee Name',
      startTime: 'Start Time',
      endTime: 'End Time',
      totalAmount: 'Total Amount',
      remark: 'Remark',
      status: 'Status',
      importSuccess: 'Import Success',
      importFailed: 'Import Failed'
    },
    aFeeDetailDiscount: {
      roomName: 'Room(Building-Unit-Room)',
      discountId: 'Discount ID',
      discountName: 'Discount Name',
      applyType: 'Apply Type',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      createTime: 'Create Time',
      useStatus: 'Use Status',
      notUsed: 'Not Used',
      used: 'Used',
      returnType: 'Return Type',
      accountBalance: 'Account Balance',
      discount: 'Discount',
      returnAmount: 'Return Amount'
    },
    aFeeDetailSub: {
      parentFeeId: 'Parent Fee ID',
      childFeeId: 'Child Fee ID',
      feeName: 'Fee Name',
      feeObject: 'Fee Object',
      billingPeriod: 'Billing Period',
      splitTime: 'Split Time'
    }
  },
  zh: {
    adminFeeDetail: {
      feeInfo: '费用信息',
      paymentRecord: '缴费记录',
      relatedRoom: '关联房屋',
      relatedCar: '关联车辆',
      relatedContract: '关联合同',
      modifyRecord: '修改记录',
      feeItem: '费用项',
      owner: '业主',
      sameFeeObj: '同费用对象',
      relatedMeter: '关联抄表',
      relatedImport: '关联导入',
      discountApply: '优惠申请',
      reprintReceipt: '补打收据',
      feeSplit: '费用拆分'
    },
    adminFeeDetailInfo: {
      feeId: '费用ID',
      feeFlag: '费用标识',
      feeType: '费用类型',
      payerObj: '付费对象',
      feeItem: '费用项',
      feeState: '费用状态',
      createTime: '建账时间',
      batchId: '批次',
      startTime: '应收开始时间',
      endTime: '应收结束时间',
      owedAmount: '欠费金额'
    },
    aRoomDetailCar: {
      placeholderCarNum: '请填写车牌号',
      carNum: '车牌号',
      leaseType: '车牌类型',
      tempCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      released: '车位已释放',
      validity: '有效期'
    },
    aFeeDetailHis: {
      feeName: '费用项',
      startTime: '建账时间',
      endTime: '计费起始时间',
      operation: '动作',
      operator: '操作人',
      operationTime: '操作时间',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
    aFeeDetailConfig: {
      feeType: '费用类型',
      feeItem: '收费项目',
      feeFlag: '费用标识',
      billType: '催缴类型',
      paymentType: '付费类型',
      prepay: '预付费',
      postpay: '后付费',
      paymentCycle: '缴费周期',
      unit: '单位',
      formula: '公式',
      unitPrice: '计费单价',
      additionalFee: '附加/固定费用',
      accountDeduction: '账户抵扣',
      mobilePayment: '手机缴费',
      decimalPlaces: '保留小数位',
      yes: '是',
      no: '否'
    },
    aFeeDetailFeeObj: {
      selectFeeObj: '请选择费用对象',
      house: '房屋',
      car: '车辆',
      contract: '合同',
      feeId: '费用编号',
      objType: '对象类型',
      objName: '对象名称',
      ownerName: '业主名称',
      phone: '手机号',
      createTime: '创建时间',
      query: '查询'
    },
    aFeeDetailImport: {
      floorNum: '楼栋编号',
      unitNum: '单元编号',
      roomNum: '房屋编号',
      feeName: '费用名称',
      startTime: '开始时间',
      endTime: '结束时间',
      totalAmount: '总金额',
      remark: '备注',
      status: '状态',
      importSuccess: '导入成功',
      importFailed: '导入失败'
    },
    aFeeDetailDiscount: {
      roomName: '房屋(楼栋-单元-房屋)',
      discountId: '折扣ID',
      discountName: '折扣名称',
      applyType: '申请类型',
      applicant: '申请人',
      applicantPhone: '申请电话',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态',
      createTime: '创建时间',
      useStatus: '使用状态',
      notUsed: '未使用',
      used: '已使用',
      returnType: '返还类型',
      accountBalance: '账户余额',
      discount: '折扣',
      returnAmount: '返还金额'
    },
    aFeeDetailSub: {
      parentFeeId: '父费用ID',
      childFeeId: '子费用ID',
      feeName: '费用名称',
      feeObject: '费用对象',
      billingPeriod: '计费时间段',
      splitTime: '拆分时间'
    }
  }
}